import React, {FC, useEffect, useState} from 'react';

import FormSelect, {ISelectOption} from "../../../commons/Select/FormSelect";
import classNames from "classnames";
import Number from "../../../commons/Input/Number";
import Input from "../../../commons/Input/Input";
import trashIcon from "../../../../assets/images/trashBin.svg";

export interface StockConvertRule {
  contains: string // "в наличии"
  operator: string // "="
  count: number
}

interface RuleRowProps {
  position: number,
  rulesCount: number,
  data?: StockConvertRule|null
  updateDataHandler: (position: number, payload: StockConvertRule) => void
  deleteRule: (position: number) => void
}

export const RuleRow: FC<RuleRowProps> = ({
  position,
  rulesCount,
  data,
  updateDataHandler,
  deleteRule,
}) => {

  // Param - contains
  const [contains, setContains] = useState<string>('');

  // Param - count
  const [count, setCount] = useState<number>(0);

  // Param - internal identity field
  const availableMapByOptions: {[key: string]: string} = {
    "": "",
    "=": "=",
    ">": "Больше",
    "<": "Меньше",
  }
  const defaultOperator = ""
  const [operator, setOperator] = useState(defaultOperator);
  const [operatorOptions, setOperatorOptions] = useState<ISelectOption[]>([]);

  const [isInited, setIsInited] = useState<boolean>(false);

  useEffect(() => {
    //
    const mapBySelectOptions: ISelectOption[] = []
    for (const key in availableMapByOptions) {
      mapBySelectOptions.push({text: availableMapByOptions[key], value: key})
    }
    setOperatorOptions(mapBySelectOptions)
    setIsInited(true)
  }, [])

  useEffect(() => {
    // @ts-ignore
    setContains(data?.contains || '')
    // @ts-ignore
    setOperator(data?.operator || defaultOperator)
    // @ts-ignore
    setCount(parseInt(data?.count || 0))
  }, [data])

  useEffect(() => {
    // без этого условия троит
    if (!isInited) {
      return
    }
    updateDataHandler(position, {contains: contains, operator: operator, count: count})
  }, [contains, operator, count])

  const customInputClassName = 'border-[#E2E8F0] mb-1 px-3 py-2 rounded-md text-sm shadow-sm placeholder-slate-400  w-full focus:outline-none focus:border-sky-500 focus:ring-1 focus:ring-sky-500 disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none'

  const isClearNotAvailable = position === 0 && rulesCount === 1 && contains.length === 0 && count < 1

  return (
      <div className="flex flex-row">

        <div className={`pr-4 flex items-center`}>Остаток</div>
        <div className={`pr-4 w-1/4`}>
          <FormSelect
              id={`googleSheet_ruleRow_operator_${position}`}
              name={`googleSheet_ruleRow_operator_${position}`}
              value={operator}
              label={null}
              changeHandler={event => setOperator(event.target.value)}
              customClassName={classNames(customInputClassName)}
              customLabelClassName="text-sm"
              blurHandler={event => setOperator(event.target.value)}
              validationError={false}
              validationErrorDescription={''}
              options={operatorOptions}
              require={false}
          ></FormSelect>
        </div>
        <div className={`pr-4 w-[100%]`}>
          <Number
              id={`googleSheet_ruleRow_contains_${position}`}
              name={`googleSheet_ruleRow_contains_${position}`}
              value={parseInt(contains) || 0}
              label={null}
              changeHandler={event => setContains(event.target.value)}
              customClassName={customInputClassName}
              customLabelClassName="text-sm"
              blurHandler={event => setContains(event.target.value)}
              min={0}
              require={true}
          />
        </div>
        <div className={`pr-4 flex items-center`}>тогда</div>
        <div className={`w-1/4`}>
          <Number
              id={`googleSheet_ruleRow_count_${position}`}
              name={`googleSheet_ruleRow_count_${position}`}
              value={count}
              label={null}
              changeHandler={event => setCount(parseInt(event.target.value))}
              customClassName={customInputClassName}
              customLabelClassName="text-sm"
              blurHandler={event => setCount(parseInt(event.target.value))}
              min={0}
              require={false}
          />
        </div>
        <div className={classNames(`pl-4`)}>
          <button
              className={classNames("flex-row justify-center items-center font-medium flex border-[1px] p-0 h-[40px] w-[40px] rounded active:outline-none")}
              onClick={() => deleteRule(position)}
              disabled={isClearNotAvailable}
              type="button"
          >
            <img src={trashIcon} alt={'Удалить'} style={isClearNotAvailable ? {filter: 'grayscale(1) brightness(1.5)'} : {}}/>
          </button>
        </div>

      </div>
  );
};
